import HttpRequest from '@/utils/httpRequest';

export function list(query) {
    return HttpRequest({
        url: 'business/ruleplan/list',
        method: 'post',
        data :query
    });
}

export function getPlanBySchool(query) {
    return HttpRequest({
        url: 'business/ruleplan/getPlanBySchool',
        method: 'get',
        params :query
    });
}

export function save(query) {
    return HttpRequest({
        url: 'business/ruleplan/save',
        method: 'post',
        data :query
    });
}

export function update(query) {
    return HttpRequest({
        url: 'business/ruleplan/update',
        method: 'post',
        data :query
    });
}
